import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";
import { Row,Col, Button } from 'reactstrap';
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class Modal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            nombre: "",
            show: false,
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            nombre: "",
            show: false,
            errors: [],
        });
    }

    getData() {
        return {
            id: this.state.id,
            nombre: this.state.nombre,
            show: this.state.show
        };
    }

    setData(data) {
        if (data.success) {
            this.setState({
                codigo: data.codigo,
                nombre: data.nombre,
                show: data.show
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Profesional",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "Profesional ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Profesional",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "Profesional ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Profesional",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Profesional",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "Profesional ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
            };
        }
    }

    render() {
        let vars = this.modalVars();
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.categorias : null)}
                submitUrl={(vars.submitType ? api.categorias : null)}
                submitType={vars.submitType}
                id={vars.id}
                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
                className="modal-lg"
            >

            <ParadigmaLabeledInput
                disabled={vars.disabled}
                md={[2, 10]}
                maxLength={100}
                label={"Nombre"}
                value={this.state.nombre}
                onChange={(e) => this.onChangeField('nombre', e.target.value)}
                error={() => this.getError('nombre')}
            />

            <ParadigmaLabeledInput
                md={[2,10]}
                label={"Visible"}
                error={() => this.getError('show')}
                inputComponent={
                    <div className="d-flex">
                        <Button
                            disabled={vars.disabled}
                            className="mr-1 flex-grow-1"
                            color={this.state.show? 'success' : 'secondary'}
                            onClick={() => this.setState({show:true})}
                        >
                            SI
                        </Button>
                        <Button
                            disabled={vars.disabled}
                            className="mr-1 flex-grow-1"
                            color={!this.state.show ? 'danger' : 'secondary'}
                            onClick={() => this.setState({show:false})}
                        >
                            NO
                        </Button>
                    </div>
                }
            />  
            </ParadigmaModal>
        );
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/views/Categorias/Modal.js